<script>
export default {
  page: {
    title: '404',
    meta: [{ name: 'description', content: '404' }],
  },
  components: {},
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <v-container>
    <h1 :class="$style.title">
      404
      <template v-if="resource">
        {{ resource }}
      </template>
      Not Found
    </h1>
    <p class="text-center">
      <span> <h2>¯\_(ツ)_/¯ </h2> </span></p
    >
  </v-container>
</template>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>
